import { render, staticRenderFns } from "./ViewComplaints.vue?vue&type=template&id=d73463ae&scoped=true"
import script from "./ViewComplaints.vue?vue&type=script&lang=js"
export * from "./ViewComplaints.vue?vue&type=script&lang=js"
import style0 from "./ViewComplaints.vue?vue&type=style&index=0&id=d73463ae&prod&scoped=true&lang=css"
import style1 from "./ViewComplaints.vue?vue&type=style&index=1&id=d73463ae&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d73463ae",
  null
  
)

export default component.exports